/*
 * Storage responsive pass (2026-10-27): the package's `Chip` is `h-7 whitespace-nowrap`, so a chip that
 * holds a phrase ("Sin fecha de fin desde el 1 set. 2026", a catalog service) is wider than a 320px row.
 * Pass this to such a chip so it can break onto a second line. The `!` is needed: both class sets sit
 * at the same specificity and their order in the stylesheet is not ours to choose.
 */
export const CHIP_WRAP = 'h-auto! min-h-7 whitespace-normal! py-0.5 text-left';
